<template>
    <v-container
      class="fill-height mb-10"
    >
      <v-row
        justify="center"
        align="center"
      >
        <v-col
          cols="12"
          md="8"
        >
          <v-card class="elevation-5">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <v-form @submit.prevent="handleSubmit(submit)">
                <v-toolbar
                  color="indigo"
                  class="lighten-1"
                  dark
                  flat
                >
                  <v-toolbar-title>Установка нового пароля</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <ValidationProvider name="detail" v-slot="{ errors }">
                    <v-alert
                      dense
                      outlined
                      type="error"
                      v-if="errors[0]"
                    >
                      <div v-html="errors[0]" class="caption"></div>
                    </v-alert>
                  </ValidationProvider>
                  <v-text-field
                        style="display: none"
                        autocomplete="new_password1 new_password2"
                      ></v-text-field>
                  <ValidationProvider name="new_password1" rules="required|min:8|max:128" v-slot="{ errors }">
                    <v-text-field
                      id="new_password1"
                      v-model="new_password1"
                      :error-messages="errors"
                      type="password"
                      label="Новый пароль"
                      autocomplete="on"
                      :messages="['Минимальная длина пароля 8 символов']"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider name="new_password2" rules="required|confirmed:new_password1|min:8|max:128"
                                      v-slot="{ errors }">
                    <v-text-field
                      id="new_password2"
                      v-model="new_password2"
                      :error-messages="errors"
                      type="password"
                      label="Новый пароль повторно"
                      autocomplete="on"
                      :messages="['Введите новый пароль еще раз']"
                    ></v-text-field>
                  </ValidationProvider>
                </v-card-text>
                <v-card-actions>
                  <help-password-recovery></help-password-recovery>
                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    right
                    class="lighten-1"
                    color="ma-2 indigo"
                    type="submit"
                    :loading="isLoading"
                  >
                    Сменить
                  </v-btn>
                </v-card-actions>
              </v-form>
            </ValidationObserver>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from "vuex";
  import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate';
  import HelpPasswordRecovery from '@/components/auth/dialogs/HelpPasswordRecovery'
  import "@/_plugins/vee-validate";
  import {confirmed, max, min, required} from "vee-validate/dist/rules";

  localize({
    ru: {
      names: {
        new_password1: ' ',
        new_password2: ' ',
      }
    }
  });

  extend('confirmed', {
    ...confirmed,
    message: 'Поле не совпадает с полем `Пароль`'
  });
  extend('required', {
    ...required
  });
  extend('max', {
    ...max
  });
  extend('min', {
    ...min
  });

  export default {
    name: "PasswordReset",
    components: {
      ValidationProvider,
      ValidationObserver,
      HelpPasswordRecovery
    },
    data() {
      return {
        new_password1: '',
        new_password2: '',
      }
    },
    props: [
      'uid',
      'token'
    ],
    watch: {
      new_password1() {
        this.$refs.observer.reset();
      },
      new_password2() {
        this.$refs.observer.reset();
      }
    },
    computed: {
      ...mapGetters("context", [
        'isLoading',
        'messages',
      ]),
      ...mapMutations("context", [
        'CLEAR_MESSAGES',
      ]),
    },
    methods: {
      ...mapActions("auth", [
        'password_reset'
      ]),
      async submit() {
        await this.$refs.observer.validate()
          .then(success => {
            if (!success) {
              return;
            }

            const payload = {
              uid: this.$props.uid,
              token: this.$props.token,
              new_password1: this.new_password1,
              new_password2: this.new_password2,
            }
            this.$store.commit("context/CLEAR_MESSAGES");
            this.$store.dispatch("auth/password_reset", payload)
              .then(() => {
                if (this.messages) {
                  this.$refs.observer.setErrors(this.messages);
                } else if (!this.messages) {
                  this.$router.push({name: "profile"}).catch(() => {})
                }
              })
              .catch(() => {
                this.$refs.observer.setErrors({
                  'detail': 'Неизвестная ошибка. Обратитесь в поддержку: <a href="mailto:abit@kuzstu.ru">abit@kuzstu.ru</a>',
                  'new_password1': ' ',
                  'new_password2': ' ',
                });
              })

            this.$nextTick(() => {
              this.$refs.observer.reset();
              this.CLEAR_MESSAGES;
            });
          })
      }
    }
  }
</script>
